import React, { useContext } from 'react';

import type { SidePanelContextValue } from './types';

export const SidePanelContext: React.Context<SidePanelContextValue | null> =
	React.createContext<SidePanelContextValue | null>(null);

/**
 * Hook to access the side panel controller context.
 * Must be used within a <SidePanelController> component.
 */
export const useSidePanel = (): SidePanelContextValue => {
	const ctx = useContext(SidePanelContext);
	if (!ctx) {
		throw new Error('useSidePanel must be used within <SidePanelController>');
	}
	return ctx;
};
